import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

interface AllocationHoverCardProps {
  allocation: {
    name: string;
    value: number;
  };
  description: {
    introduction: string;
    liquidityPosition: string;
    liquidityExplanation: string;
  };
}

const AllocationHoverCard = ({ allocation, description }: AllocationHoverCardProps) => {
  const getLiquidityWidth = (position: string): string => {
    switch (position.toLowerCase()) {
      case 'high':
        return '75%';
      case 'medium-high':
        return '65%';
      case 'moderate':
        return '50%';
      case 'low':
        return '25%';
      case 'very low':
        return '15%';
      default:
        return '50%';
    }
  };

  const getLiquidityColor = (position: string): string => {
    switch (position.toLowerCase()) {
      case 'high':
        return 'bg-green-500';
      case 'medium-high':
        return 'bg-blue-500';
      case 'moderate':
        return 'bg-yellow-500';
      case 'low':
        return 'bg-orange-500';
      case 'very low':
        return 'bg-destructive';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div className="bg-white p-3 rounded-lg border border-navy/10 cursor-help">
          <div className="text-sm text-navy-light">{allocation.name}</div>
          <div className="text-navy font-medium">{allocation.value || 0}%</div>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-[400px] p-6 bg-white shadow-lg rounded-xl border-none">
        <div className="space-y-6">
          <div className="flex justify-between items-start">
            <h3 className="text-xl font-semibold text-navy-dark">About {allocation.name}</h3>
          </div>

          <div className="space-y-4">
            <div>
              <h4 className="text-lg font-medium mb-2 text-navy">Introduction</h4>
              <p className="text-gray-700 leading-relaxed">
                {description.introduction}
              </p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg space-y-3">
              <div className="flex items-center justify-between">
                <h4 className="text-lg font-medium text-navy">Liquidity Index</h4>
              </div>
              
              <div className="relative">
                <div className="h-2 bg-gray-200 rounded-full">
                  <div 
                    className={`absolute left-0 h-2 ${getLiquidityColor(description.liquidityPosition)} rounded-full transition-all duration-300`}
                    style={{ width: getLiquidityWidth(description.liquidityPosition) }}
                  />
                </div>
                <div className="mt-2 text-sm font-semibold uppercase text-navy-dark">
                  {description.liquidityPosition}
                </div>
              </div>

              <p className="text-sm text-gray-600 mt-2">
                {description.liquidityExplanation}
              </p>
            </div>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default AllocationHoverCard;
